import React from 'react';
import { gridConnectionDetailsRoute } from '@/modules/charge-center/grid-connections/grid-connection-details/route';
import { createRoute } from '@tanstack/react-router';

// ! I think this will use the old connectors table and should be a different component as the one used for ALL connectors
export const gridConnectionConnectorsRoute = createRoute({
  getParentRoute: () => gridConnectionDetailsRoute,
  path: 'connectors',
  component: React.lazy(async () => await import('@/app/routes/ChargeCenter/ConnectorTab')),
  wrapInSuspense: true,
});
